import React, { useState } from 'react';
import Tippy from '@tippyjs/react';
import { useDispatch } from 'react-redux';

import { styledDriverJourneys } from './styled';
import { listMounted, listUnMounted } from './redux/effects';
import List from './List';

const driverJourneysContext = React.createContext();

export function useDriverJourneysContext() {
  const context = React.useContext(driverJourneysContext);
  if (context === undefined) {
    return { isInsideDriverJourneys: false };
  }
  return context;
}

const DriverJourneys = ({ children, className, driverId, customTrigger = null }) => {
  const [renderList, setRenderList] = useState(false);

  const dispatch = useDispatch();

  const handleAfterHide = () => {
    dispatch(listUnMounted());
    setRenderList(false);
  };

  const handleAfterShow = () => {
    dispatch(listMounted({ driverId }));
    setRenderList(true);
  };

  return (
    <driverJourneysContext.Provider value={{ isInsideDriverJourneys: true }}>
      <Tippy
        interactive
        onShow={handleAfterShow}
        onHidden={handleAfterHide}
        interactiveBorder={10}
        maxWidth="none"
        placement="bottom"
        theme="light"
        trigger={customTrigger || 'mouseenter'}
        className={className}
        content={renderList && <List />}
      >
        <span>{children}</span>
      </Tippy>
    </driverJourneysContext.Provider>
  );
};

export default styledDriverJourneys(DriverJourneys);
